const uamfApiErrorMessages = {
    SESSION_NOT_ACTIVE: 'SESSION_NOT_ACTIVE',
    ENVIRONMENT_MISMATCH: 'ENVIRONMENT_MISMATCH',
    DEVICE_NOT_FOUND: 'DEVICE_NOT_FOUND',
    ACTIVE_REQUEST_ALREADY_EXISTS: 'ACTIVE_REQUEST_ALREADY_EXISTS',
};

export default uamfApiErrorMessages;
